import { Drawer } from 'antd';
import React from 'react';

type IndexProps = {
  title: string;
  visible: boolean;
  json: JSON | undefined;
  setIsShowJSON: () => void;
}

const Index: React.FC<IndexProps> = ({ title, visible, setIsShowJSON, json }) => {


  return <Drawer
    title={title}
    width={500}
    placement="right"
    onClose={setIsShowJSON}
    visible={visible}
  >
    {json && (
      <div
        style={{
          background: '#183045',
          color: 'rgba(255, 255, 255, 0.8)',
          padding: 8,
          whiteSpace: 'pre-wrap',
          fontSize: 13
        }}
      >
        {JSON.stringify(json, null, 4)}
      </div>
    )}
  </Drawer>
}

export default React.memo(Index);